import { convertBpToPercentageDecimal, formatNumberLocale } from "@/utils/helpers";
import { useTranslation } from "react-i18next";
import { useIntl } from "react-intl";

export type TenderOverviewDetails = {
  margin: number;
  estimateMargin: number;
  revenue: number;
  totalCost: number;
  minutes: number;
  surcharge: number;
}

interface Props {
  overviewDetails: TenderOverviewDetails;
}

function TenderOverviewDetailsComponent({ overviewDetails }: Props) {

  //
  const intl = useIntl();
  const { t } = useTranslation(["components"]);

  return (
    <div data-cy="tender-overview-details-component" className="flex shrink-0 text-xs gap-4">
      <div className="flex shrink-0 gap-2">
        <div className="text-gray-400">{t("tenderoverviewdetails.margin")}</div>
        <div>{formatNumberLocale(intl, convertBpToPercentageDecimal((overviewDetails.margin ?? overviewDetails.estimateMargin)), "percent")}</div>
      </div>
      <div className="flex shrink-0 gap-2">
        <div className="text-gray-400">{t("tenderoverviewdetails.surcharge")}</div>
        <div>{formatNumberLocale(intl, convertBpToPercentageDecimal(overviewDetails.surcharge), "percent")}</div>
      </div>
      <div className="flex shrink-0 gap-2">
        <div className="text-gray-400">{t("tenderoverviewdetails.profit")}</div>
        <div>{formatNumberLocale(intl, overviewDetails.revenue - overviewDetails.totalCost, "currency")}</div>
      </div>
      <div className="flex shrink-0 gap-2">
        <div className="text-gray-400">{t("tenderoverviewdetails.revenue")}</div>
        <div>{formatNumberLocale(intl, overviewDetails.revenue, "currency")}</div>
      </div>
      <div className="flex shrink-0 gap-2">
        <div className="text-gray-400">{t("tenderoverviewdetails.hours")}</div>
        <div>{formatNumberLocale(intl, (overviewDetails.minutes ?? 0) / 60, "decimal")}</div>
      </div>
    </div>
  );
}

export default TenderOverviewDetailsComponent;
